export default "__VITE_ASSET__BwMHv1OQ__"